module.exports = __webpack_public_path__ + "img/addon-eventsaas.ae6f0a27.png";